<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rECV2n/tc-custom/9781467451420.jpg?1728851792745" alt="This image is the cover for the book Eschatology, Guides to Theology (GT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eschatology, Guides to Theology (GT)
      </h1>
      <p class="bookDescription body article font2">
        <p>This short textbook, the latest volume in the Guides to Theology series, surveys key themes and aspects of Christian hope by tracing eschatological ideas as they have developed from Scripture throughout the history of theology.</p><p>John McDowell and Scott Kirkland present a series of lenses on understanding eschatological statements, or the content of Christian hope. They have structured their book thematically into five chapters—four exploring apocalyptic, existential, political, and christological themes, followed by an extensive annotated bibliography. Within each chapter, McDowell and Kirkland take a history-of-ideas approach, locating the various perspectives in their historical contexts. Concise and accessible, this book is ideal for introductory undergraduate courses in eschatology.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John C. McDowell, Scott A. Kirkland
      </h2>
      
      <p class="authorDescription body article"><BR /><B>John C. McDowell</B>&#160;is professor of theology and director of research at the University of Divinity in Melbourne, Australia.<BR /><BR /><B>Scott A. Kirkland</B>&#160;is a postdoctoral research associate at Trinity College Theological School, University of Divinity, Melbourne.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66ad27c9